import { render } from "./EscanerPage.vue?vue&type=template&id=6c33bf49&scoped=true"
import script from "./EscanerPage.vue?vue&type=script&lang=js"
export * from "./EscanerPage.vue?vue&type=script&lang=js"

import "./EscanerPage.vue?vue&type=style&index=0&id=6c33bf49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c33bf49"]])

export default __exports__